import React, { useCallback, memo, useState, useEffect } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import TopMenu from './TopMenu';
import './Layout.css';

const Layout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [notificacoes, setNotificacoes] = useState(0);
  const [showNotificacoes, setShowNotificacoes] = useState(false);
  const [listaNotificacoes, setListaNotificacoes] = useState([]);

  const handleLogout = useCallback(() => {
    logout();
    navigate('/login');
  }, [logout, navigate]);

  useEffect(() => {
    if (user) {
      carregarNotificacoes();
      // Atualizar a cada 30 segundos
      const interval = setInterval(carregarNotificacoes, 30000);
      return () => clearInterval(interval);
    }
  }, [user]);

  const carregarNotificacoes = async () => {
    try {
      const response = await api.get('/notificacoes/contador');
      if (response.data.success) {
        setNotificacoes(response.data.data.total || 0);
      }
    } catch (err) {
      // Ignorar erros silenciosamente
    }
  };

  const carregarListaNotificacoes = async () => {
    try {
      const response = await api.get('/notificacoes/listar');
      if (response.data.success) {
        setListaNotificacoes(response.data.data);
      }
    } catch (err) {
      // Ignorar erros
    }
  };

  const handleToggleNotificacoes = () => {
    if (!showNotificacoes) {
      carregarListaNotificacoes();
    }
    setShowNotificacoes(!showNotificacoes);
  };

  return (
    <div className="layout">
      <header className="layout-header">
        <div className="layout-header-content">
          <h1 className="layout-logo">DocLine</h1>
          <div className="layout-user">
            <span className="user-name">{user?.nome_completo}</span>
            <div className="notificacoes-container">
              <button 
                className="btn-notificacoes"
                onClick={handleToggleNotificacoes}
                title="Notificações"
              >
                🔔
                {notificacoes > 0 && (
                  <span className="notificacao-badge">{notificacoes > 99 ? '99+' : notificacoes}</span>
                )}
              </button>
              {showNotificacoes && (
                <div className="notificacoes-dropdown">
                  <div className="notificacoes-header">
                    <h3>Notificações</h3>
                    <button onClick={() => setShowNotificacoes(false)}>✕</button>
                  </div>
                  <div className="notificacoes-list">
                    {listaNotificacoes.length === 0 ? (
                      <div className="notificacao-empty">
                        <p>Nenhuma notificação</p>
                      </div>
                    ) : (
                      listaNotificacoes.map((notif) => (
                        <div key={notif.id_tramitacao} className="notificacao-item">
                          <div className="notificacao-icon">📄</div>
                          <div className="notificacao-content">
                            <strong>Documento recebido</strong>
                            <p>{notif.protocolo?.numero_protocolo} - {notif.protocolo?.assunto}</p>
                            <small>
                              De: {notif.setor_origem?.nome_setor || notif.usuario_origem?.nome_completo}
                            </small>
                          </div>
                        </div>
                      ))
                    )}
                  </div>
                  {listaNotificacoes.length > 0 && (
                    <div className="notificacoes-footer">
                      <button 
                        className="btn-ver-todos"
                        onClick={() => {
                          navigate('/documentos');
                          setShowNotificacoes(false);
                        }}
                      >
                        Ver todos os documentos
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
            <button onClick={handleLogout} className="btn-logout">
              Sair
            </button>
          </div>
        </div>
      </header>
      <TopMenu />
      <main className="layout-main">
        <Outlet />
      </main>
    </div>
  );
};

export default memo(Layout);

